import { ApproverLayoutStoreSlice, approverLayoutReducer } from "../features";

export interface ApproverStoreSlices {
  approverLayout: ApproverLayoutStoreSlice;
}

export const approverReducers = {
  approverLayout: approverLayoutReducer,
};
